<template>
  <div styleName="opt_ppt_courseware_wp">
    <div styleName="opt_ppt_dynamic_tips_wp" v-if="dynamicTips">
      <div v-show="isSpread" styleName="opt_ppt_dynamic_tips_detail_wrap">
        <p styleName="opt_ppt_dynamic_tips_detail" v-html="dynamicTips" @mouseout="closeTips"></p>
      </div>
      <div styleName="opt_ppt_dynamic_tips_btn" v-show="!isSpread" @mouseover="showTips">Tips
        <span styleName="opt_ppt_dynamic_tips_icon"></span>
      </div>
    </div>
    <iframe :src="dynamicSrc" id="dynamicIfr" frameborder="0" width="100%" height="100%" v-if="getSn && signalReady"></iframe>
    <StaticPPT v-else-if="!getSn"></StaticPPT>
  </div>
</template>
<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import StaticPPT from '@/components/StaticPPT'
import { signalSdk } from '@/utils/getSDK'
import createBridge from '@/utils/service'
import { mapGetters } from 'vuex'
import { coursewareURL } from '@/config'
import sensorLog from '@/utils/sensorLog';
import * as types from '../../constants'
import { downloadAudio } from '@/utils/mixing'
import api from '@/api/index'
let micVolume = 20
export default {
  mixins: [CSSModules(styles)],
  components: {
    StaticPPT
  },
  data () {
    return {
      courseType: 2, // 1为静态课件，2为动态课件
      scale: 480 / 640, // 课件的宽高比
      dynamicOptions: {
        role: 1,
        sn: 'OPEN1-U1-LC1-L3_b31a055241f29b388ebd66bcf6de5c5c.json', // 默认课件标识
        cdn: 'https://ic-static.vipkid.com.cn/course/lessonjsonVIPKIDOP/',
        from: 'zy-vk', // 来源，双师: zy-ss，vk: zy-vk
        classType: 2, // 1v1 or 1vN
        pn: 1, // 页码
        mode: 2 // 1: 预览；2.直播|监课；3.回放
      },
      bridge: null, // 课件容器内外通信桥
      audioPathList: [], // 课件全部音频资源路径列表
      audioHostList: [], // 课件音频资源对应的域名列表
      audioSrc: '',
      dynamicTips: '', // 老师课件提示标语
      isSpread: false, // Tips提示语展开状态
      signalReady: false,
      currentAudioElem: null, // 当前正在混音音频对应的元素节点
      audioSrcList: []
    }
  },
  computed: {
    ...mapGetters(['roomDetail', 'enterSignalRoom']),
    dynamicSrc () {
      let { roomRole, userId, roomId, onlineClassId } = this.roomDetail.data
      return `${this.dynamicPath}/#/?role=${roomRole}&sn=${this.getSn}&userid=${userId}&roomid=${roomId}&classid=${onlineClassId}&classType=${this.dynamicOptions.classType}&timestamp=${new Date().getTime()}`
    },
    getSn () {
      console.log('====this.roomDetail.data.lessonSerialNumber=====', this.roomDetail.data.lessonSerialNumber)
      console.log('====this.signalReady', this.signalReady)
      return this.roomDetail.data.lessonSerialNumber
    },
    dynamicPath () {
      return `${coursewareURL}`
    }
  },
  watch: {
    '$store.getters.enterSignalRoom.data': {
      handler (val) {
        if (val.status && val.status === 1) {
          this.signalReady = true
          this.$nextTick(() => {
            if (this.getSn) {
              this.createBridge()
              this.bindMixingEvents()
            }
          })
        }
      },
      immediate: true
    }

  },
  destroyed () {
    this.bridge && this.bridge.removeMsgEventListener()
    // 销毁动态课件后恢复混音现场
    if (this.currentAudioElem) {
      this.$audioMixing.stopMixing()
      this.$audioMixing.deleteAudio()
      this.$audioMixing.resumeDefaultVolume()
      this.$audioMixing.disconnectMediaElementFromDest()
      this.currentAudioElem = null
    }
  },
  methods: {
    createBridge () {
      // iframe 发送消息
      let $ifr = document.querySelector('#dynamicIfr')
      this.bridge = createBridge($ifr, coursewareURL)

      // 动态课件ready
      this.bridge.addListener('ready', data => {
        sensorLog.track("ppt_bridge_ready_listener", types.SENSORLOG.type.SUCCESSED)
        let sn = this.getSn
        signalSdk.sendPresentationChange(1, 0, sn, sn).then(() => {
          sensorLog.track("ppt_bridge_ready_send_presentation_change", types.SENSORLOG.type.SUCCESSED, JSON.stringify(sn))
        })
      })
      // 动态课件加载error
      this.bridge.addListener('error', data => {
        sensorLog.track("ppt_bridge_error_listener", types.SENSORLOG.type.FAILED, JSON.stringify(data))
      })
      // 监听容器日志记录
      this.bridge.addListener('coursewarelog', log => {
        sensorLog.track("ppt_bridge_log_listener", types.SENSORLOG.type.SUCCESSED, JSON.stringify(log))
      })
      // 监听容器发出的课件数据
      this.bridge.addListener('data', (e, callback) => {
        sensorLog.track("ppt_bridge_data_listener", types.SENSORLOG.type.SUCCESSED, JSON.stringify(e))
        this.sendInteractiveClassData(e, callback)
      })
      // 监听投票
      this.bridge.addListener('publicData', res => {
        sensorLog.track("ppt_bridge_publicData_listener", types.SENSORLOG.type.SUCCESSED, JSON.stringify(res))
        this.sendInteractiveClassPublicData(res)
        let { msgtype } = res
        console.log('msgtype', res)
        console.log('msgtype', msgtype === '73')
        if (msgtype === '73') {
          api.updateQuestionTime()
            .then((res) => {
              sensorLog.track("update_questiontime", types.SENSORLOG.type.SUCCESSED, JSON.stringify(res))
            })
            .catch((err) => {
              sensorLog.track("update_questiontime", types.SENSORLOG.type.FAILED, JSON.stringify(err))
            })
        }

      })
      // 监听课件列表所有答题信息
      this.bridge.addListener('questionList', res => {
        // console.log('=================questionList===========', res)
        sensorLog.track("update_questioninfo_iframe", types.SENSORLOG.type.SUCCESSED, JSON.stringify(res))
        api.updateQuestioninfo({ questionList: res.idList })
          .then((res) => {
            sensorLog.track("update_questioninfo", types.SENSORLOG.type.SUCCESSED, JSON.stringify(res))
          })
          .catch((err) => {
            sensorLog.track("update_questioninfo", types.SENSORLOG.type.FAILED, JSON.stringify(err))
          })
      })


      // 监听容器音频数据
      this.bridge.addListener('audio', args => {
        sensorLog.track("ppt_bridge_audio_listener", types.SENSORLOG.type.SUCCESSED, JSON.stringify(args))

        try {
          args = JSON.parse(args)
        } catch (ex) { }
        let { cmd, res, volume } = args

        console.log('============audio==========')
        // 如果请求执行预加载
        if (cmd === 'preload') {
          let { audioList, domainList } = res
          if (audioList.length === 0) return
          this.audioHostList = domainList['vipkid']['teacher']
          // 预加载所有的音频资源
          this.audioPreload([].concat(this.audioHostList), audioList)
        }

        // 如果请求音频状态变更
        if (cmd === 'requestUpdate') {
          let requestUpdateStatus = res.status
          switch (requestUpdateStatus) {
            case 'play':
              this.startMixing(res.src, volume)
              break
            case 'pause':
              this.pauseMixing(res.src)
              break
            case 'resume':
              this.resumeMixing(res.src)
              break
            default:
              break
          }
        }
        // 监听课件的提示内容
        this.bridge.addListener('tips', res => {
          sensorLog.track("ppt_bridge_tips_listener", types.SENSORLOG.type.SUCCESSED, JSON.stringify(res))
          this.dynamicTips = res.text
        })
      })
    },
    sendInteractiveClassData (e, callback) {
      let count = 0
      let send = function () {
        signalSdk.sendInteractiveClassData(e)
          .then(res => {
            sensorLog.track("ppt_interactive_callback_history", types.SENSORLOG.type.SUCCESSED, JSON.stringify(res))
            callback(null, res.result[1]) // 拉取历史数据
          })
          .catch((res, code) => { // 信令发送失败3次之内继续发送
            count++
            sensorLog.track("ppt_interactive_callback_history", types.SENSORLOG.type.FAILED, JSON.stringify({ ...res, code, count }))
            if (count === 3) return
            // callback(err)
            send()
          })
      }
      send()
    },
    sendInteractiveClassPublicData (res) {
      let self = this
      let count = 0

      let send = function () {
        signalSdk.sendInteractiveClassPublicData(res)
          .then(res => {
            let { msgtype } = res.msg
            console.log('===============msgtype===========', res)
            if (+msgtype === 73) {
              self.bridge.postMessage('receivePublic', JSON.stringify(res.msg))

            }
            sensorLog.track("ppt_interactive_public_data", types.SENSORLOG.type.SUCCESSED, JSON.stringify(res))
          })
          .catch((res, code) => {
            count++
            sensorLog.track("ppt_interactive_public_data", types.SENSORLOG.type.FAILED, JSON.stringify({ ...res, code, count }))
            if (count === 3) return
            send()
          })
      }
      send()
    },
    showTips () {
      this.isSpread = true
    },
    closeTips () {
      this.isSpread = false
    },
    // 监听混音时间
    bindMixingEvents () {
      if (!this.$audioMixing) {
        return
      }
      let self = this
      // 订阅停止
      // 重置之前的mp3播放状态
      this.$audioMixing.mixingStoped().subscribe(args => {
        console.warn('[dynamic-stop]', self.getAudioName(args['filePath']))
        this.$audioMixing.resumeDefaultVolume() // 恢复混音中麦克风的音量
        self.bridge.postMessage('excuteAudioStatusChange', {
          code: 0,
          data: {
            src: self.getAudioName(args['filePath']),
            status: 'finish',
            current: 0,
            total: 0
          }
        })
      })
      // 订阅进度
      this.$audioMixing.mixingProgress().subscribe(args => {
        console.log('[dynamic-progress]', self.getAudioName(args['filePath']))
        self.bridge.postMessage('excuteAudioStatusChange', {
          code: 0,
          data: {
            src: self.getAudioName(args['filePath']),
            status: 'update',
            current: args['currentTime'],
            total: args['totalTime']
          }
        })
      })
      // 订阅完成
      this.$audioMixing.mixingFinished().subscribe(args => {
        console.warn('[dynamic-finish]', self.getAudioName(args['filePath']))
        this.$audioMixing.resumeDefaultVolume() // 恢复混音中麦克风的音量
        self.bridge.postMessage('excuteAudioStatusChange', {
          code: 0,
          data: {
            src: self.getAudioName(args['filePath']),
            status: 'finish',
            current: 0,
            total: args['totalTime']
          }
        })
      })
    },
    getAudioName (audioPath) {
      let reg = /\w+\.mp3$/i
      return audioPath.match(reg)[0]
    },
    // 开始混音
    async startMixing (audioPath, volume = 100) {
      let audioSrc = ''
      // 从缓存中获取当前播放的mp3地址
      try {
        this.audioSrcList.forEach((source, index) => {
          if (~source.indexOf(audioPath)) {
            this.audioSrc = audioSrc = source
          }
        })
      } catch (ex) {
        console.warn('[dynamic-startmixing]code:1.msg:', ex.message)
        this.bridge.postMessage('excuteAudioStatusChange', {
          code: -1,
          data: {
            src: this.getAudioName(audioSrc),
            status: 'play',
            current: 0,
            total: 0
          }
        })
        throw ex
      }

      // 混音
      try {
        let { audio } = await this.$audioMixing.startMixing({
          filePath: audioSrc,
          volume
        })
        this.$audioMixing.setMicroVolume(micVolume) // 开始混音降低麦克风音量
        console.log('audio mixed volume=====', volume)
        if (!this.currentAudioElem) {
          this.currentAudioElem = audio
          this.$eventSource.emit('AUDIO_MOUNTED', this.currentAudioElem) // 音频挂载完成触发事件用于判断是否需要进行混音
        }
        console.warn('[dynamic-startmixing]success', audioSrc)
        this.bridge.postMessage('excuteAudioStatusChange', {
          code: 0,
          data: {
            src: this.getAudioName(audioPath),
            status: 'play',
            current: 0,
            total: 0
          }
        })
        sensorLog.track("ppt_start_mixing", types.SENSORLOG.type.SUCCESSED, JSON.stringify(this.getAudioName(audioPath)))
      } catch (ex) {
        sensorLog.track("ppt_start_mixing", types.SENSORLOG.type.FAILED, JSON.stringify({ msg: ex.message, filePath: audioSrc }))
        this.bridge.postMessage('excuteAudioStatusChange', {
          code: -2,
          data: {
            src: this.getAudioName(audioPath),
            status: 'play',
            current: 0,
            total: 0
          }
        })
        throw ex
      }
    },
    // 暂停混音
    async pauseMixing (audioPath) {
      // let filePath = await this.checkVideo([].concat(this.audioHostList), audioPath, 1000)
      let filePath = this.audioSrc
      console.log('file path=====', filePath)
      try {
        await this.$audioMixing.pauseMixing()
        this.$audioMixing.resumeDefaultVolume() // 暂停混音恢复麦克风音量
        console.warn('[dynamic-pausemixing]success', filePath)
        this.bridge.postMessage('excuteAudioStatusChange', {
          code: 0,
          data: {
            src: this.getAudioName(filePath),
            status: 'pause',
            current: 0,
            total: 0
          }
        })
        sensorLog.track("ppt_pause_mixing", types.SENSORLOG.type.SUCCESSED)
      } catch (ex) {
        sensorLog.track("ppt_pause_mixing", types.SENSORLOG.type.FAILED, JSON.stringify({ msg: ex.message, filePath }))
        this.bridge.postMessage('excuteAudioStatusChange', {
          code: -1,
          data: {
            src: this.getAudioName(filePath),
            status: 'pause',
            current: 0,
            total: 0
          }
        })
      }
    },
    // 恢复混音
    async resumeMixing () {
      let filePath = this.audioSrc
      try {
        await this.$audioMixing.resumeMixing(filePath)
        this.$audioMixing.setMicroVolume(micVolume) // 恢复混音降低麦克风音量
        console.warn('[dynamic-resumemixing]success', filePath)
        this.bridge.postMessage('excuteAudioStatusChange', {
          code: 0,
          data: {
            src: this.getAudioName(filePath),
            status: 'play',
            current: 0,
            total: 0
          }
        })
      } catch (ex) {
        sensorLog.track("ppt_resume_mixing", types.SENSORLOG.type.FAILED, JSON.stringify({ msg: ex.message, filePath }))
        this.bridge.postMessage('excuteAudioStatusChange', {
          code: -1,
          data: {
            src: self.getAudioName(filePath),
            status: 'play',
            current: 0,
            total: 0
          }
        })
      }
    },
    // 缓存音频
    audioPreload (audioHostList, audioPathList) {
      let currentAudioPath = audioPathList.shift()
      this.checkVideo(audioHostList, currentAudioPath, 3000)
        .then(() => {
          if (audioPathList.length) {
            this.audioPreload([].concat(this.audioHostList), audioPathList)
          }
        })
        .catch(() => {
          if (audioPathList.length) {
            this.audioPreload([].concat(this.audioHostList), audioPathList)
          }
        })
    },
    // 根据提供的域名列表和音频地址预加载音频文件
    // 并将预加载完成的音频文件地址存入列表
    async checkVideo (audioHostList, path, timeout) {
      let filePath
      try {
        filePath = await downloadAudio(audioHostList, path, 'audio', timeout)
        this.audioSrcList.push(filePath)
        return filePath
      } catch (ex) {
        sensorLog.track("ppt_audio_preload", types.SENSORLOG.type.FAILED, JSON.stringify({ msg: ex.message, filePath: path }))
        throw ex
      }
    }
  }
}
</script>

<style>
.fold_wp.fold-enter-active,
.fold_wp.fold-leave-active {
  transition: opacity 0.2s ease;
}

.fold_wp.fold-enter,
.fold_wp.fold-leave-to {
  opacity: 0;
}
</style>

